import React, { useMemo, useState } from "react"
import { getTableSortingHeaderIcon } from "helpers/common"
import TableContainer from "components/Common/TableContainer"
import RaisedQueriesViewModal from "./RaisedQueriesViewModal"
import eye from "../../assets/images/icons/eye.svg"
import { UncontrolledTooltip } from "reactstrap"
import { Link } from "react-router-dom"

const RaisedQueries = ({ investorData, data = [] }) => {
  const [open, setOpen] = useState(false)
  const [selectedQuery, setSelectedQuery] = useState(null)
  const columns = useMemo(() => {
    const baseColumns = [
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
        id: "created_at",
        accessorFn: (row) =>
          row?.created_at ? new Date(row.created_at).getTime() : null,
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => row.original.formatted_created_at,
      },
      {
        header: "Queries",
        accessorKey: "unique_code",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div
            dangerouslySetInnerHTML={{
              __html: row?.original.steps
                .map((item) => item.label)
                .join(",<br/> "),
            }}
          />
        ),
      },
      {
        header: "Status",
        accessorKey: "pan_no",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="code-status">
            {investorData.status === "APPROVED" ? (
              <div className={`badge approved`}>
                <span></span> Approved
              </div>
            ) : (
              <>
                {row?.original.status === "PENDING" ? (
                  <div className={`badge kyc_pending`}>
                    <span></span> Pending
                  </div>
                ) : (
                  <div className={`badge under_review`}>
                    <span></span> Under Review
                  </div>
                )}
              </>
            )}
          </div>
        ),
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => {
          const viewTooltip = `editTooltip-${row?.original.id}`
          return (
            <div className="action-view">
              <Link
                to={"#"}
                id={viewTooltip}
                onClick={() => {
                  setSelectedQuery(row?.original)
                  setOpen(true)
                }}
              >
                <img src={eye} alt="" />
                <UncontrolledTooltip placement="top" target={viewTooltip}>
                  View
                </UncontrolledTooltip>
              </Link>
            </div>
          )
        },
      },
    ]

    return baseColumns
  }, [])
  return (
    <React.Fragment>
      <div className="raised-queries">
        <TableContainer
          filters={{ page: 1, pageSize: 100 }}
          columns={columns}
          data={data}
          isGlobalFilter={false}
          isCustomPageSize={false}
          isPagination={false}
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered   table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </div>
      {open && selectedQuery && (
        <RaisedQueriesViewModal
          steps={selectedQuery?.steps}
          open={open}
          setOpen={setOpen}
        />
      )}
    </React.Fragment>
  )
}

export default RaisedQueries
